import { useFunnel } from '../hooks/useOnboardingQueries';
import type { RecoverSession } from '../hooks/useSessionRecovery';
import { FunnelCard } from './FunnelCard';

export interface FunnelFeedProps {
  sessionId: string;
  /** Brings the BFF session back when the read finds it gone. */
  recover?: RecoverSession;
  brand?: string | null;
  site?: string;
}

/** The funnel card, owning the funnel poll (mounted only once the card is shown, so nothing here starts FA early). */
export function FunnelFeed({ sessionId, recover, brand, site }: FunnelFeedProps) {
  const funnel = useFunnel(sessionId, true, recover);
  return <FunnelCard funnel={funnel} brand={brand} site={site} />;
}
